import { render, staticRenderFns } from "./award_picture.vue?vue&type=template&id=38728afc&scoped=true&"
import script from "./award_picture.vue?vue&type=script&lang=js&"
export * from "./award_picture.vue?vue&type=script&lang=js&"
import style0 from "./award_picture.vue?vue&type=style&index=0&id=38728afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38728afc",
  null
  
)

export default component.exports